export default __webpack_public_path__ + "static/media/wake_up.4f9b370e.mp3";